import { render, staticRenderFns } from "./FootNav.vue?vue&type=template&id=c6f53f32&scoped=true&"
import script from "./FootNav.vue?vue&type=script&lang=js&"
export * from "./FootNav.vue?vue&type=script&lang=js&"
import style0 from "./FootNav.vue?vue&type=style&index=0&id=c6f53f32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f53f32",
  null
  
)

export default component.exports